import {
  overlay,
  type OverlayAsyncControllerComponent,
  type OverlayControllerComponent,
} from 'overlay-kit';

// 고정 overlayId 는 이 파일로만 연다 — lint(zep/no-restricted-syntax)가 직접 지정을 막는다.
// overlay-kit 은 열린 id 를 다시 open 하면 렌더 중 throw 해 전역 에러 화면으로 간다(QUIZ-APP-5WA).
// close 직후 open 은 기존 항목 재오픈으로 처리돼 열린 모달이 그대로 남는다(새 controller 는 버려짐).

export function openOverlayOnce(
  overlayId: string,
  controller: OverlayControllerComponent,
) {
  overlay.close(overlayId);
  const options = { overlayId };
  return overlay.open(controller, options);
}

export function openOverlayOnceAsync<T>(
  overlayId: string,
  controller: OverlayAsyncControllerComponent<T>,
) {
  overlay.close(overlayId);
  const options = { overlayId };
  return overlay.openAsync<T>(controller, options);
}
